angular.module('bmsApp.crm.salespipeline').factory('SalesPipelineSvc', function ($q,
																		  CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/salespipeline', params);
		}
	};

}).factory('SalesPipelineStatusesSvc', function ($q,
                                         CRUDSvc) {

    return {
        index: function (params) {
            return CRUDSvc.get('api/salespipelinestatuses', params);
        }
    };

});
